import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface TutorialCategory {
  category_slug: string;
  count: number;
}

export function useTutorialCategories() {
  const [categories, setCategories] = useState<TutorialCategory[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    async function fetchCategories() {
      try {
        setLoading(true);
        const { data, error: fetchError } = await supabase
          .from('tutorials')
          .select('category_slug')
          .eq('published', true)
          .not('category_slug', 'is', null);

        console.log('CATEGORY DEBUG', data);

        // Group by category_slug and count occurrences
        const categoryMap = new Map<string, number>();
        data?.forEach(tutorial => {
          if (tutorial.category_slug) {
            categoryMap.set(
              tutorial.category_slug, 
              (categoryMap.get(tutorial.category_slug) || 0) + 1
            );
          }
        });

        // Convert to array and sort alphabetically
        const categoriesArray = Array.from(categoryMap.entries())
          .map(([category_slug, count]) => ({ category_slug, count }))
          .sort((a, b) => a.category_slug.localeCompare(b.category_slug));

        setCategories(categoriesArray);
      } catch (err) {
        console.error('Error fetching tutorial categories:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    }

    fetchCategories();
  }, []);

  return { categories, loading, error };
}